/* eslint-disable react-refresh/only-export-components */
import { createBrowserRouter, Navigate } from "react-router-dom";
import React, { lazy, Suspense } from "react";
import { LoadingSpinner } from "../components/ui/loading-spinner";

// Layout components
import { AppShell } from "../components/layout/AppShell";
import { ErrorBoundary } from "../components/layout/ErrorBoundary";

// Lazy load components for better performance
const EERC = lazy(() => import("../pages/EERC"));

// Loading component for lazy-loaded routes
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-[200px]">
    <LoadingSpinner size="lg" />
  </div>
);

// Wrapper component for lazy-loaded pages
const LazyWrapper = ({ children }: { children: React.ReactNode }) => (
  <ErrorBoundary>
    <Suspense fallback={<PageLoader />}>{children}</Suspense>
  </ErrorBoundary>
);

// Error fallback component for router
const RouterErrorBoundary = () => (
  <ErrorBoundary>
    <div>An error occurred while loading the page.</div>
  </ErrorBoundary>
);

// Route definitions
export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    errorElement: <RouterErrorBoundary />,
    children: [
      {
        index: true,
        element: <Navigate to="/ewatr?mode=standalone" replace />,
      },
      {
        path: "ewatr",
        element: (
          <LazyWrapper>
            <EERC />
          </LazyWrapper>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/ewatr?mode=standalone" replace />,
  },
]);

// Navigation utilities
export const routes = {
  eerc: "/ewatr",
} as const;

export type RouteKey = keyof typeof routes;

// Navigation metadata for sidebar and breadcrumbs
type NavigationItem = {
  key: RouteKey | "eerc-converter";
  label: string;
  path: string;
  icon: "shield" | "coins" | "exchange";
  description?: string;
};

export const navigationConfig: NavigationItem[] = [
  {
    key: "eerc",
    label: "Standalone Mode",
    path: "/ewatr?mode=standalone",
    icon: "coins",
  },
  {
    key: "eerc-converter",
    label: "Converter Mode",
    path: "/ewatr?mode=converter",
    icon: "exchange",
  },
];
